// Runtime-first env lookup. Deployed containers can't rebuild the bundle, so
// apps/_shared/entrypoint.sh writes the container's VITE_* env vars to /env.js
// (loaded by index.html before the app bundle) as window.__IPLAN_ENV__.
// Bake-time import.meta.env only applies to local dev / CI builds.
declare global {
  interface Window {
    __IPLAN_ENV__?: Record<string, string | undefined>;
  }
}

export function getEnv(key: string): string | undefined {
  const runtime = typeof window !== 'undefined' ? window.__IPLAN_ENV__?.[key] : undefined;
  if (runtime !== undefined && runtime !== '') {
    return runtime;
  }
  const baked = import.meta.env[key] as string | undefined;
  return baked !== undefined && baked !== '' ? baked : undefined;
}
